import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class EnginesService {

    constructor(private http: Http) {
    }

    getAll() {
        return this.http
                   .get(`${environment.apiUrl}/admin/engines`)
                   .map(this.extractData);
    }

    update(engineId, assignedUserId) {
        return this.http
                   .put(`${environment.apiUrl}/admin/engines/${engineId}`, assignedUserId ? {user_id: assignedUserId} : {})
                   .catch(this.handleError);
    }

    restart(engine: RV.Engine) {
        const url = `${environment.apiUrl}/admin/engines/${engine.id}/maintenance/reboot`;

        return this.http
                   .post(url, null)
                   .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || [];
    }

    private handleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/engines.service.ts